// ReduxToolkit/Reducers/ViewReducer.js
import { createSlice } from "@reduxjs/toolkit";

const viewSlice = createSlice({
  name: "view",
  initialState: {
    activeView: null,
    params: {
      register_id: null,
      customer_id: null,
      cashier_id: null,
      product_id: null,
      product: null,
    },
  },
  reducers: {
    openView: (state, action) => {
      state.activeView = action.payload; // e.g., "customers", "products"
    },
    openViewWithParams: (state, action) => {
      const { view, params } = action.payload;
      state.activeView = view;
      state.params = { ...params };
    },
    closeView: (state) => {
      state.activeView = null;
    },
  },
});

export const { openView, openViewWithParams, closeView } = viewSlice.actions;
export default viewSlice.reducer;
